import axiosBackend from "core/api/backend";

export default function LoadReportsList({
    appUUID,
}) {
    return axiosBackend({
        method: "POST",
        url: `/service/reports/${appUUID}/`,
    })
}